import { find } from "lodash";
import React, { useContext, useEffect } from "react";
import {
  Box as B,
  Circle as C,
  pointInCircle,
  pointInPolygon,
  Vector as V,
} from "sat";

import QuestionContext from "../QuestionContext";

import ImageMap from "./common/image-map/ImageMap";
import Mark from "./common/image-map/Mark";
import Prompt from "./shared/Prompt";

const GraphicSelectPoint = (props) => {
  const [player, dispatchPlayer] = useContext(QuestionContext);

  // Reveal Key
  useEffect(() => {
    if (player.revealKey) {
      let key;
      for (let spotId in props.data.scoring.spots) {
        if (props.data.scoring.spots[spotId].isKey) {
          key = spotId;
          break;
        }
      }
      let spot = find(props.data.content.spots, ["id", key]);
      if (!spot) return;
      // console.log("spot?", props.data.content.spots, spot, key);

      // todo: adjust mark for for shape type/size
      dispatchPlayer({
        type: "RESPONSE",
        data: {
          id: props.data.id,
          score: true,
          response: {
            coords:
              spot.shape === "rect"
                ? {
                    x: spot.coords.x + spot.coords.w / 2,
                    y: spot.coords.y + spot.coords.h / 2,
                  }
                : {
                    x: spot.coords.x,
                    y: spot.coords.y,
                  },
          },
        },
      });
    }
  }, [player.revealKey]);

  // Score response
  let mark;
  if (player.scoreResponses && player.response?.[props.data.id]) {
    mark = "incorrect";
    let rsp = player.response[props.data.id].coords;
    let test;

    if (props.data.content.spots) {
      props.data.content.spots.map((s) => {
        let spotIsKey = props?.data?.scoring?.spots?.[s.id]?.isKey;
        if (!spotIsKey) {
          return;
        }

        // console.log(
        //   "test spot",
        //   props?.data?.scoring?.spots?.[s.id]?.isKey,
        //   rsp,
        //   s.coords
        // );
        switch (s.shape) {
          case "circle":
            test = pointInCircle(
              new V(rsp.x, rsp.y),
              new C(new V(s.coords.x, s.coords.y), s.coords.r),
            );
            if (test) {
              mark = "correct";
            }
            break;
          case "rect":
            test = pointInPolygon(
              new V(rsp.x, rsp.y),
              new B(
                new V(s.coords.x, s.coords.y),
                s.coords.w,
                s.coords.h,
              ).toPolygon(),
            );
            if (test) {
              mark = "correct";
            }
            break;
        }
      });
    }
  }

  const getImage = () => {
    return props.data.content.image;
  };

  return (
    <div className="item-player-element item-player-stem item-player-stem-graphic-select-point">
      <Prompt data={props.data.content.prompt} />
      {props.data.content.image && (
        <ImageMap
          image={props.data.content.image}
          onClick={(e) => {
            dispatchPlayer({
              type: "RESPONSE",
              data: {
                id: props.data.id,
                response: {
                  coords: {
                    x: e.evt.layerX,
                    y: e.evt.layerY,
                  },
                },
              },
            });
          }}
        >
          {player?.response?.[props.data.id]?.coords && (
            <Mark
              type={mark}
              x={player.response[props.data.id].coords.x}
              y={player.response[props.data.id].coords.y}
            />
          )}
        </ImageMap>
      )}
    </div>
  );
};
export default GraphicSelectPoint;
